import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { gsap } from 'gsap/dist/gsap';
import { SplitText } from 'gsap/dist/SplitText';
import { useRouter } from 'next/router';
import { useWindowSize } from 'u9/hooks';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import Link from 'next/link';

import Footer from 'u9/containers/footer/footer'
import BaseLink from 'u9/components/baseLink/baseLink';

import * as Styled from './haveQuestions.styles';
import { colors } from 'utils/styles/theme';


interface HaveQuestionsProps {}

const HaveQuestions = ({ ...restProps }: HaveQuestionsProps) => {
  const { locale } = useRouter();

  return (
    <Styled.Layout>
      <div>
        Have Questions
      </div>
      <div>
        <Link href="/get-in-touch" locale={locale}>
          <BaseLink label="Get in Touch" color={'balticSea'}/>
        </Link>
      </div>
    </Styled.Layout>
  );
};

export default HaveQuestions;
